<template>
  <div
    class="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 bg-primary text-white text-sm px-4 py-2"
  >
    <span class="flex items-center gap-2">
      <span class="material-symbols-outlined">rocket_launch</span>
      Khabeer is moving to Workspace and will be retired soon. Everything you do
      here is already there, plus a lot more.
    </span>
    <a
      :href="workspaceUrl"
      class="inline-flex items-center gap-1 px-3 py-1 rounded bg-white text-primary font-medium whitespace-nowrap"
    >
      Go to Workspace
      <span class="material-symbols-outlined text-base">arrow_forward</span>
    </a>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { workspaceUrl } from "@/helpers/workspaceUrl";

export default Vue.extend({
  data() {
    return { workspaceUrl };
  },
});
</script>
